enum TimePeriods {
    DATE = "DATE",
    HOUR = "HOUR",
    DAY = "DAY",
    WEEK = "WEEK",
    MONTH = "MONTH",
    YEAR = "YEAR",
};

export default TimePeriods;